import { render, staticRenderFns } from "./CallDiagnostic.vue?vue&type=template&id=20764302"
import script from "./CallDiagnostic.vue?vue&type=script&lang=js"
export * from "./CallDiagnostic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports